/**
 * Домены для подсветки карточек в отчёте глобального поиска.
 * Указывайте хост без схемы и без www, в нижнем регистре.
 * Совпадение: сам хост или любой его поддомен (например, companies.rbc.ru и foo.companies.rbc.ru).
 * Пополняйте массив по мере необходимости.
 */
export const GLOBAL_SEARCH_HIGHLIGHT_DOMAINS = ['companies.rbc.ru'];

function normalizeDomainToken(d) {
  return String(d)
    .trim()
    .toLowerCase()
    .replace(/^www\./, '');
}

/** Нормализованный список для сравнения */
export function getNormalizedHighlightDomains(list = GLOBAL_SEARCH_HIGHLIGHT_DOMAINS) {
  if (!Array.isArray(list)) return [];
  return list.map(normalizeDomainToken).filter(Boolean);
}

/**
 * @param {string | null | undefined} host — уже нормализованный hostname (без www), lower-case
 */
export function hostMatchesHighlightDomain(host, domains = GLOBAL_SEARCH_HIGHLIGHT_DOMAINS) {
  if (!host || typeof host !== 'string') return false;
  const h = host.trim().toLowerCase();
  const normalized = getNormalizedHighlightDomains(domains);
  return normalized.some((d) => h === d || h.endsWith(`.${d}`));
}
